__webpack_require__.p = "/Alogic-Clone/";